module.exports = __webpack_public_path__ + "static/blackcat-white-7bae83297a528c0ea93d2dc06311379f.png";